import React, { useContext, useEffect, useMemo, useState } from 'react';
//useMemo
import { CSVLink } from 'react-csv';

import Axios from 'axios';
import _ from 'lodash';

import styled from 'styled-components';

import { getCsvSeparator } from '@libs/CsvUtils';
import { deaccentizeandlowerize } from '@libs/NwUtils';

//import CustomersPdf from '@components/ContactsExporter/CustomersPdf';
//import ModelsPdf from '@components/ContactsExporter/ModelsPdf';
//import RadioButtonGroup from "@components/Gui/NWForm/RadioButtonGroup";
import { ListContext } from '@contexts/ListContext';
import { useUserPermission } from '@contexts/UserContext';
import { useUserGuiConfig } from '@contexts/UserGuiConfigContext';

import Switch from '@components/Gui/CustomSwitch';
import { NwButton } from '@components/Gui/NwButton';

//import { PDFDownloadLink } from '@react-pdf/renderer';
import { byPrefixAndName } from '@awesome.me/kit-d6dae216cd/icons';

/**
 * Chiave di ordinamento dei contatti: accenti normalizzati e caratteri speciali ignorati,
 * così "Álvarez" e "D'Angelo" finiscono dove ci si aspetta. Gli spazi restano separatori.
 */
const getContactSortKey = (value) =>
    deaccentizeandlowerize(String(value || ''))
        .replace(/[^a-z0-9\s]/g, '')
        .replace(/\s+/g, ' ')
        .trim();

const Wrapper = styled.div`
    padding: 0;

    p {
        margin: 0.5rem 0;
    }

    /* lo switch della colonna e la sua eventuale opzione stanno sulla stessa riga */
    p.data-selection-row {
        display: flex;
        align-items: center;
        gap: 1.5rem;
    }

    .button-container {
        text-align: left;
        margin-top: 1.6rem;
    }
`;

const ContactsExporter = ({ headers, type, data, headerExtras }) => {
    const { cachedList } = useContext(ListContext);
    const userGuiConfig = useUserGuiConfig();
    const csvSeparator = getCsvSeparator(userGuiConfig);
    const customFields =
        type === 'model'
            ? cachedList.customFields.items['Model']
            : [
                  ...cachedList.customFields.items['Client'],
                  ...cachedList.customFields.items['Agency'],
                  ...cachedList.customFields.items['Service'],
              ];
    const validCustomFields =
        customFields && customFields.length > 0
            ? customFields.filter((field) => !field.Disabled).map((field) => field.Name)
            : [];

    let headersWithCustomFields = [...headers];
    validCustomFields.forEach((field) => {
        const fieldname = field.replace(/_/g, ' ');
        const fieldNameCapitalize = fieldname.replace(/(^\w{1})|(\s+\w{1})/g, (letter) => letter.toUpperCase());
        headersWithCustomFields.push({ key: field, label: fieldNameCapitalize });
    });

    const [csvHeaders, setCSVHeaders] = useState(
        headersWithCustomFields.map((header) => ({ ...header, checked: true }))
    );
    //const [documentType, setDocumentType] = useState('csv');
    //const [showPictures, setShowPictures] = useState(false);
    //const [showPhones, setShowPhones] = useState(true);
    //const [showAdditionalInfo, setShowAdditionalInfo] = useState(false);
    //const [startGeneratingPdf, setStartGeneratingPdf] = useState(false);
    const [customFieldsByContactID, setCustomFieldsByContactID] = useState(null);
    // gli switch di selezione colonne sono nascosti finché l'utente non clicca "select data"
    const [showDataSelection, setShowDataSelection] = useState(false);

    const getCustomFieldsValues = async () => {
        const customFieldsValues = await Axios.post('/contacts/customfields', {
            ContactIDs: data.map((contact) => contact.ID),
        });
        const customFieldsByContact = new Map();
        for (const cfv of customFieldsValues) {
            if (cfv.CustomFields) {
                customFieldsByContact.set(cfv.ContactID, cfv.CustomFields);
            }
        }
        setCustomFieldsByContactID(customFieldsByContact);
    };

    useEffect(() => {
        getCustomFieldsValues();
    }, []);

    // i custom field si caricano una volta sola, ma le righe si ricompongono a ogni cambio di
    // `data`: un'opzione che cambia i valori esportati deve arrivare fino al file
    const dataWithCustomFields = useMemo(() => {
        if (!customFieldsByContactID) {
            return [];
        }
        const contactsWithCustomFields = data.map((contact) => {
            const customFields = customFieldsByContactID.get(contact.ID);
            return customFields ? { ...contact, ...customFields } : contact;
        });
        const sortFields = [(contact) => getContactSortKey(contact.name)];
        if (type === 'model') {
            sortFields.push((contact) => getContactSortKey(contact.surname));
        }
        return _.orderBy(contactsWithCustomFields, sortFields);
    }, [data, customFieldsByContactID, type]);

    const handleCSVHeaderChange = (header) => (checked) => {
        const csvHeaderIndex = csvHeaders.findIndex((item) => item.key === header.key);
        const newCSVHeaders = [...csvHeaders];
        newCSVHeaders[csvHeaderIndex].checked = checked;
        setCSVHeaders(newCSVHeaders);
    };

    // const onChangePdf = () => {
    //     setStartGeneratingPdf(false);
    // }

    // const handleChangePdfPictures = (value) => {
    //     onChangePdf();
    //     setShowPictures(value);
    // }

    // const handleChangePdfPhones = (value) => {
    //     onChangePdf();
    //     setShowPhones(value);
    // }

    // const handleChangePdfAdditionalInfo = (value) => {
    //     onChangePdf();
    //     setShowAdditionalInfo(value);
    // }

    return (
        <Wrapper>
            <p>
                <strong>Export selected data as a CSV file</strong>
            </p>
            <br />
            {/* <p>
                <RadioButtonGroup
                    value={documentType}
                    onChange={setDocumentType}
                    options={[
                        { label: 'PDF', value: 'pdf' },
                        { label: 'CSV', value: 'csv' }
                    ]} />
            </p> */}
            {/* {documentType === 'csv' ? */}
            {!showDataSelection ? (
                <NwButton
                    primary
                    icon={byPrefixAndName.fasl['file-spreadsheet']}
                    label="select data"
                    onClick={() => setShowDataSelection(true)}
                />
            ) : (
                <>
                    {headersWithCustomFields.map((header, index) => {
                        const csvHeader = csvHeaders.find((item) => item.key === header.key);
                        return (
                            <p className="data-selection-row" key={`${header.key}-${index}`}>
                                <Switch
                                    text={header.label}
                                    checked={csvHeader.checked}
                                    onChange={handleCSVHeaderChange(header)}
                                />
                                {/* opzione della colonna, resa dal chiamante */}
                                {headerExtras && headerExtras[header.key]}
                            </p>
                        );
                    })}
                    <div className="button-container">
                        <CSVLink
                            filename={type === 'model' ? 'models.csv' : 'customers.csv'}
                            data={dataWithCustomFields}
                            headers={csvHeaders.filter((header) => header.checked)}
                            separator={csvSeparator}
                        >
                            <NwButton
                                primary
                                icon={byPrefixAndName.fasl['file-spreadsheet']}
                                label="export csv file"
                            />
                        </CSVLink>
                    </div>
                </>
            )}
            {/* : <>
                    {type === 'model' &&
                        <p>
                            <Switch
                                text={'Show pictures'}
                                checked={showPictures}
                                onChange={handleChangePdfPictures}
                            />
                        </p>
                    }
                    <p>
                        <Switch
                            text={type === 'model' ? 'Show phones and e-mail' : 'Show phones'}
                            checked={showPhones}
                            onChange={handleChangePdfPhones} />
                    </p>
                    <p>
                        <Switch
                            text={'Show additional info'}
                            checked={showAdditionalInfo}
                            onChange={handleChangePdfAdditionalInfo} />
                    </p>
                    <div className="button-container">
                        {startGeneratingPdf
                            ?
                            <PDFDownloadLink
                                document={type === 'model' ?
                                    <ModelsPdf
                                        showPictures={showPictures}
                                        showPhones={showPhones}
                                        showAdditionalInfo={showAdditionalInfo}
                                        contacts={data} />
                                    : <CustomersPdf
                                        showPhones={showPhones}
                                        showAdditionalInfo={showAdditionalInfo}
                                        contacts={data} />
                                }
                                fileName={type === 'model' ? `models.pdf` : 'customers.pdf'}>
                                {({ loading }) => (
                                    loading
                                    ?
                                        <NwButton loading primary icon={byPrefixAndName.fasl['file-pdf']} label='generate file' />
                                    :
                                        <NwButton primary icon={byPrefixAndName.fasl['cloud-arrow-down']} label='download file' />
                                    )
                                }
                            </PDFDownloadLink>
                            :
                            <NwButton primary icon={byPrefixAndName.fasl['file-pdf']} label='generate file' onClick={() => setStartGeneratingPdf(true)} />
                        }
                    </div>
                </>
            } */}
        </Wrapper>
    );
};

export default ContactsExporter;
